<template>
  <div style="overflow: hidden;width: 100%">
    <CommonHeader/>
    <div class="container" style="min-height: calc(100vh - 56px - 88px);">
      <a-row>
        <a-col class="mt-3 mb-3" :span="24">
          <a-breadcrumb>
            <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
            <a-breadcrumb-item>公告</a-breadcrumb-item>
          </a-breadcrumb>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="18">
          <a-card>
            <div class="p_text_bg">
              <div class="text-header">
                <h3 class="size6 mb-7" style="font-size: 24px;">{{ announce.announceName }}</h3>
                <br>
                <div class="d-flex justify-content-between" style="font-size: 14px;color: #8c8c8c;">
                  <span>项目编号: &nbsp;&nbsp;{{ announce.projectCode }}</span>
                  <span class="border-left">发布时间:&nbsp;&nbsp;{{ announce.publishTime }}</span>
                </div>
              </div>

              <div class="mt-6">
                <div>
                  <div class="announce-content" v-html="announce.announceContent">
                  </div>
                <!--   如果是采购公告或公示-->
                  <div v-if="'1,6'.includes(announce.announceType)" style="text-align: right">
                    <div v-if="announce.downloadType && announce.downloadType === '2'">
                      <div v-if="hideFile" style="text-align: center">
                        <a href="javascript:;">报名后可以下载</a>
                      </div>
                      <div v-else>
                        <!--                                            <upload-selector :referId='announce.projectId' readonly="readonly" configKey='purchase_doc'/>-->
                        <!--                                  <upload-selector :referId='announce.projectId' readonly="readonly" configKey='purchase_pdf'/>-->
                        <upload-selector :referId='announce.projectId' readonly="readonly" configKey='purchase_doc'/>
                        <upload-selector :referId='announce.announceId' readonly="readonly" configKey='tender_file'/>
                      </div>
                    </div>
                    <div style="text-align: right" v-else-if="announce.downloadType && announce.downloadType === '1'">
                      <upload-selector :referId='announce.projectId' readonly="readonly" configKey='purchase_doc'/>
                      <upload-selector :referId='announce.announceId' readonly="readonly" configKey='tender_file'/>
                    </div>
                    <div style="text-align: right">
                      <upload-selector :referId='announce.announceId' readonly="readonly" configKey='common_tender_file'/>
                    </div>
                  </div>
                  <div style="text-align: right" v-else>
                    <upload-selector :referId='announce.announceId' readonly="readonly" configKey='tender_file'/>
                    <upload-selector v-if="announce.announceType==='3'" :referId='announce.announceId' readonly="readonly" configKey='JG-GG-ZX-QY-SMH'/>
                  </div>
                </div>
              </div>
            </div>
          </a-card>
          <div class="titleAnnounce mt-6 mb-3">本项目其它公告</div>
          <a-table :pagination="false" ref="table" :columns="columns" :rowKey="record => record.announceId"
                   :data-source="announceList">
            <template slot="name" slot-scope="text">
              <a>{{ text }}</a>
            </template>
            <template slot="announceName" slot-scope="record">
              <a href="javascript:;"
                 @click="onSwitch(record.announceId)">{{ record.announceName }}</a>
            </template>
            <template slot="publishTime" slot-scope="record">
              {{ record.publishTime }}
            </template>
          </a-table>
        </a-col>
        <a-col :span="6">
          <a-card class="text-center">
            <div>
              <svg class="icon d-block" aria-hidden="true"
                   style="width: 50px;height: 50px;margin: auto">
                <use xlink:href="#icon-tips"></use>
              </svg>
            </div>
          </a-card>
          <a-card class="mt-0 p-0">
            <div class="border-bottom p-5">
              <p class="mb-1">采购单位:</p>
              <p class="color-black mb-0"> {{ bid.purchaserUnit }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">采购方式:</p>
              <p class="color-black mb-0"> {{ bid.methodName }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">报名截止日期:</p>
              <template v-if="bid.bmjzsjList && bid.bmjzsjList.length>0">
                <p class="color-black mb-0" v-if="bid.bmjzsjList.length === 1"> {{ formatDate(bid.bmjzsjList[0].dateTime) }} </p>
                <p class="color-black mb-0" v-else v-for=" bmsj in bid.bmjzsjList"> {{bmsj.packAlias}}:{{ formatDate(bmsj.dateTime) }} </p>
              </template>
            </div>

            <div class="border-bottom p-5">
              <p class="mb-1">开标日期:</p>
              <template v-if="bid.kbsjList && bid.kbsjList.length>0">
                <p class="color-black mb-0" v-if="bid.kbsjList.length === 1"> {{ formatDate(bid.kbsjList[0].dateTime) }} </p>
                <p class="color-black mb-0" v-else v-for=" kbsj in bid.kbsjList"> {{kbsj.packAlias}}:{{ formatDate(kbsj.dateTime) }} </p>
              </template>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">项目联系人:</p>
              <p class="color-black mb-0"> {{ bid.projectConcat }} </p>
            </div>
            <div class="border-bottom p-5">
              <p class="mb-1">联系电话:</p>
              <p class="color-black mb-0"> {{ bid.projectConcatTel }} </p>
            </div>
          </a-card>
          <!--                    <a-button v-if="bid.signUpState === 0" class="mt-4" type="primary" size="large" @click="signPermission"-->
          <!--                                  block>我要报名-->
          <!--                        </a-button>-->
          <!--                        <a-button v-if="bid.signUpState === 1" class="mt-4" size="large" block>报名已截止</a-button>-->
          <template v-if="bid.signUpState === 0">
            <a-button v-if="announce.onlineSign && announce.onlineSign === '0'" class="mt-4" size="large" block>
              本项目不支持线上报名
            </a-button>
            <a-button v-else class="mt-4" type="primary" size="large" @click="signPermission" block>我要报名</a-button>
          </template>
          <template v-else-if="bid.signUpState === 1">
            <a-button class="mt-4" size="large" block>报名已截止</a-button>
          </template>
          <template v-else-if="bid.signUpState === -1">
            <a-button class="mt-4" size="large" block>未开始报名</a-button>
          </template>
        </a-col>
      </a-row>
    </div>
    <CommonFooter/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import qs from 'qs'
import CommonHeader from '../common/CommonHeader'
import CommonFooter from '../common/CommonFooter'
import UploadSelector from '@/components/selector/UploadSelector'
import moment from "moment";

const columns = [
  {
    title: '项目公告列表',
    // dataIndex: 'announceName',
    scopedSlots: {customRender: 'announceName'},
    align: 'left'
  },
  {
    title: '发布时间',
    scopedSlots: {customRender: 'publishTime'},
    align: 'right',
  },
];
export default {
  components: {
    CommonHeader,
    CommonFooter,
    UploadSelector
  },
  created() {
    this.initDetails(this.id)
  },
  watch: {},
  data() {
    return {
      data: [],
      id: this.$route.query.id,
      announceId: this.$route.query.id,
      announce: '',
      announceList: [],
      bid: '',
      columns,
      hideFile: false
    }
  },
  methods: {
    initDetails(announceId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getDetails/' + announceId).then(function (res) {
        if (res.code == 200) {
          console.log(res.result)
          that.announce = res.result
          if (that.announce.systemType === '2') {
            that.$router.push({path: '/project/announce?id=' + announceId})
          } else if (that.announce.systemType === '1') {
            that.initCard(that.announce.projectId)
            that.initList(announceId)
            that.isSignUp(that.announce.projectId)
          }
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    initCard(projectId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getSimpleBid/' + projectId + "/1").then(function (res) {
        if (res.code == 200) {
          that.bid = res.result
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    initList(announceId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/aboutOtherAnnounce/' + announceId).then(function (res) {
        if (res.code == 200) {
          that.announceList = res.result
        }
      });
    },
    isSignUp(projectId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/isSignUp/' + projectId).then(function (res) {
        if (res === false) {
          that.hideFile = true
        }
      })
    },
    formatDate(value) {
      if (!value) {
        return "未设置"
      }
      value = value.replace(new RegExp(/-/gm), "/")
      value = moment(new Date(value)).format("YYYY-MM-DD HH:mm")
      return value
    },
    onSwitch(announceId) {
      this.reloadDetails(announceId)
    },
    reloadDetails(announceId) {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getDetails/' + announceId).then(function (res) {
        if (res.code == 200) {
          that.announce = res.result
          that.initList(announceId)
        } else {
          that.$message.error('数据加载失败')
        }
      });
    },
    sign() {
      this.$router.push({path: '/LegalSignIndex?id=' + this.bid.id})
    },
    showConfirm(value) {
      let that = this
      this.$confirm({
        title: "提示",
        content: value,
        okText: '立即认证',
        cancelText: '知道了',
        onOk() {
          that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
            that.$router.push({path: '/enterprise/LegalCertificationIndex'});
          });
        },
        onCancel() {
        }
      });
    },
    signPermission() {
      let that = this
      that.$http.get('/api/v1/supplier/legalsign/legalSignPermission.json?projectId=' + that.bid.id).then(function (data) {
        if (data.code === 100) {
          that.$error({
            title: '提示',
            content: data.msg,
            okText: '确定',
            onOk() {

            }
          })
        } else if (data.code === 300) {
          that.showConfirm(data.msg)
        } else if (data.code === 301) {
          that.$confirm({
            title: "提示",
            content: data.msg,
            okText: '立即认证',
            cancelText: '继续报名',
            onOk() {
              that.$http.get('/api/v1/supplier/getAccountInfo.json').then(function (res) {
                that.$router.push({path: '/enterprise/LegalCertificationIndex'});
              });
            },
            onCancel() {
              that.sign()
            }
          });
        } else if (data.code === 400) {
          that.$confirm({
            title: '提示',
            content: data.msg,
            okText: '前往资格审查',
            onOk() {
              that.$router.push({path: '/ZgYsFile?projectId=' + that.bid.id})
            },
            onCancel() {
            }
          })
        } else if (data.code === 600) {
          that.$confirm({
            title: '提示',
            content: data.msg,
            okText: '提交资格审查文件',
            onOk() {
              that.$router.push({path: '/BmscFile?projectId=' + that.bid.id})
            },
            onCancel() {

            }
          })
        } else if (data.code === 700) {
          that.$info({
            title: '提示',
            content: data.msg,
          })
        } else if (data.code === 200) {
          that.sign()
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.text-header {
  text-align: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 24px;
  font-size: 18px;
}

.text-header span {
  flex: 1;
}

.p_text_bg {
  border: 1px dashed #ccc;
  padding: 20px;
}

/deep/ .announce-content p {
  line-height: 30px;
}

/deep/ .announce-content ul {
  list-style: none;
}

/deep/ .p-0 .ant-card-body {
  padding: 0;
}

/deep/ .ant-tabs-nav .ant-tabs-tab {
  font-size: 20px;
  font-weight: bold;
}

/deep/ .ant-tabs-bar {
  margin-bottom: 0;
  border-bottom: 3px solid #e6e6e6;
}

/deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
  background: #fff;
}

.titleAnnounce {
  border-left: 3px solid #2F7FE3;
  padding-left: 16px;
  color: #333;
  font-size: 20px;
}

.border-bottom .p-5 {
  font-size: 14px;
}
</style>
